import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import PsContext from "../../context";
import { DB_POSTFIX, LOADER_LOGO, upperCase } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

const AnnouncementsList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);

  useEffect(() => {
    loadData();
  }, [props.match.params]);

  const loadData = () => {
    setLoader(true);
    axios
      .get(
        ServiceUrl.LIST_PAGES +
          "?sadb=" +
          DB_POSTFIX +
          "&type=announcement&upcoming=1"
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
          //  console.log(res["data"].data);
        }
        setLoader(false);
      });
  };

  const field = (fieldName) => dataList[fieldName] || "";

  return (
    <div style={{ minHeight: "350px" }}>
      {/*<section>
        <div className="head-2">
          <div className="container">
            <div className="head-2-inn head-2-inn-padd-top">
              <h1>ANNOUNCEMENTS LIST</h1>
            </div>
          </div>
        </div>
      </section>*/}

      {loader && (
        <center className="py-5">
          <img src={LOADER_LOGO.default} />
        </center>
      )}
      <section>
        <div className="container com-sp pad-bot-70 pg-inn ps_min_height px-5 ">
          <h5>ANNOUNCEMENTS LIST</h5>
          <hr />
          {dataList.length > 0 && (
            <>
              <Row>
                {dataList.map((item, i) => {
                  return (
                    <Col md={12}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.content_html,
                        }}
                      />
                    </Col>
                  );
                })}
              </Row>
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default AnnouncementsList;
